// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	ExpandableContent: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "ExpandableContent" */
				'./index'
			),
	} ),
};
